// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from '../../config/config';

// Define a service using a base URL and expected endpoints
export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config().apiUrl,
    credentials: 'same-origin',
  }),
  // tagTypes: patientDataTags,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({email, password}) => ({
        url: 'token/',
        method: 'POST',
        body: {email: email.toLowerCase(), password},
      }),
      // invalidatesTags: patientDataTags,
    }),
    logout: builder.mutation({
      queryFn: () => ({data: null}),
      invalidatesTags: ['*'],
    }),
    createMFACode: builder.mutation({
      query: ({email}) => ({
        url: 'mfa/',
        method: 'POST',
        body: {email},
      })
    }),
    claimMFACode: builder.mutation({
      query: ({email, code}) => ({
        url: 'mfa/',
        method: 'PUT',
        body: {email, code},
      })
    }),
    resetPassword: builder.mutation({
      query: ({email}) => ({
        url: 'reset-password/start',
        method: 'POST',
        body: {email: email.toLowerCase()},
      })
    }),
    completeResetPassword: builder.mutation({
      query: ({email, token, password}) => ({
        url: 'reset-password/complete',
        method: 'POST',
        body: {email: email.toLowerCase(), token, password},
      }),
      invalidatesTags: ['*'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useResetPasswordMutation,
  useCompleteResetPasswordMutation,
  useCreateMFACodeMutation,
  useClaimMFACodeMutation,
} = authApi;
